// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownH1Extended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-h1.svg?react';
import { createIcons } from '../../Icon';
const MarkdownH1Icon = /* @__PURE__ */ createIcons('MarkdownH1', {
    extended: MarkdownH1Extended
});
MarkdownH1Icon.supportedTypes = [
    'extended'
];
MarkdownH1Icon.category = 'markdown';
export default MarkdownH1Icon;
